import { createSlice } from '@reduxjs/toolkit'
import { Profession } from '../../../model/profession.model'
import { initialStoreState } from '../../initialState'

const professionSlice = createSlice({
  name: 'professions',
  initialState: initialStoreState.professions,
  reducers: {
    professionsSet: (state, action) => {
      return action.payload
    },
    professionAdded: (state, action) => {
      state.push(action.payload)
    },
    professionUpdated: (state, action) => {
      return state.map((prof: Profession) => {
        if (prof.profession_id !== action.payload.profession_id) {
          // This isn't the item we care about - keep it as-is
          return prof
        }
        // // Otherwise, this is the one we want - return an updated value incl. nested values

        return {
          ...prof,
          ...action.payload,
          ...prof.specalities,
          ...action.payload.specalities,
        }
      })
    },
    professionRemoved: (state, action) => {
      return state.filter(
        (profession) => profession?.profession_id !== action.payload
      )
    },
  },
})

export const {
  professionsSet,
  professionAdded,
  professionUpdated,
  professionRemoved,
} = professionSlice.actions

export default professionSlice.reducer